import ExecutorFactory from 'shared/execution/executor-factory';

const executorFactory = new ExecutorFactory();

export default executorFactory;
